import { Button } from "primereact/button";
import * as React from "react";
import { useTranslation } from "react-i18next";
import "./PrwcTextButton.scss";

const PrwcTextButton = (props: any) => {
  const { onClick, labelKey, className, type = "button", icon } = props;
  const { t } = useTranslation();

  return (
    <span className="prw-text-button">
      <Button
        icon={icon}
        label={t(labelKey)}
        onClick={onClick}
        type={type}
        className={className}
      />
    </span>
  );
};

export default PrwcTextButton;
